import { Address } from './address.model';
import { Phone } from './phone.model';

export class CustomerFullData {
    public customerId: string;
    public name: string;
    public firstName: string;
    public lastName: string;
    public birthDate: string;
    public emailAddress: string;
    public state: string;
    public lastPurchaseDate: string;
    public address: Address;
    public phoneNumbers: Array<Phone>;
    public gender: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/customer-full-data.model.ts